/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".footer-box[_ngcontent-%COMP%]{min-height:50px;margin-top:-50px}.footer-box[_ngcontent-%COMP%]   .page-footer[_ngcontent-%COMP%]   .footer-copyright[_ngcontent-%COMP%]{background-color:#fff}"];
export { styles as styles };
